import React from 'react';
import {connect} from 'react-redux';
import queryString from 'query-string';
import SystemUserResults from './ResultsPages/SystemUserResults';
import SystemUserEditor from './EditorPages/SystemUserEditor';

function SystemUsers({
    urlParams
}) {
    const queryParams = queryString.parse(urlParams);

    return (
        queryParams && queryParams['id'] ?
            <SystemUserEditor id={queryParams['id']} /> :
            <SystemUserResults />
    );
}

const mapStateToProps = (state) => ({
    urlParams: state.router.location.search,
});

export default connect(mapStateToProps, null)(SystemUsers);